/*
  Inspired by: https://github.com/muxinc/elements/blob/116d6f0361c64f0efddae8b35a0af7176ce26e9a/packages/mux-player/src/index.ts#L497
*/
let muxVideo = null;
let tracks = null;
let selectedTrack = null;

const isFirefox = /Firefox/i.test(navigator.userAgent);

const cuechangeHandler = () => {
  const activeCues = Array.from(
    (selectedTrack && selectedTrack.activeCues) || [],
  );

  activeCues.forEach((cue) => {
    /*
      Some transcripts contain cues that read "[BLANK_AUDIO]", "[ Silence ]", "*Music*".
      To hide these cues, we will set the cue text to an empty string and move it out of view.
     */
    if (['[BLANK_AUDIO]', '[ Silence ]', '*Music*'].includes(cue.text.trim())) {
      cue.text = '';
      cue.line = 0;

      return;
    }

    /*
     By default, video captions display at the bottom of the video player and are obscured
     by the controls. For webkit browsers we move the captions above the controls using
     the webkit-text-track-transform property. For Firefox, we move the captions
     above the controls by adjusting the line property of active cues.
   */
    if (!isFirefox) return;

    /*
      Ignore cues that are
        - Positioned vertically via percentage.
        - Not at the bottom
          - line is less than -7
          - line is between 0 and 10
    */
    if (!cue.snapToLines || cue.line < -7 || (cue.line >= 0 && cue.line < 10)) {
      return;
    }

    // For cues that have more than one line, we want to push the cue further up
    const lines = cue.text.split('\n').length;

    // If the video is muted, we need to push the captions up one more line
    const offset = muxVideo.muted ? -5 : -4;

    cue.line = offset - lines;
  });
};

const selectTrack = () => {
  const newSelectedTrack = Array.from(tracks || []).filter(
    (t) => ['subtitles', 'captions'].includes(t.kind) && t.mode === 'showing',
  )[0];

  selectedTrack?.removeEventListener('cuechange', cuechangeHandler);

  selectedTrack = newSelectedTrack;

  selectedTrack?.addEventListener('cuechange', cuechangeHandler);
};

export default () => {
  muxVideo = document.getElementsByTagName('mux-video')[0];

  if (!muxVideo) {
    return;
  }

  tracks = muxVideo.textTracks;

  tracks.addEventListener('change', selectTrack);

  selectTrack();

  muxVideo.addEventListener('volumechange', cuechangeHandler);
};
